import { toast as rawToast } from "react-toastify";
import translateServerMessage from "./serverMessages";

// Drop-in replacement for `import { toast } from "react-toastify"`.
// Content-rendering methods (success/error/info/warn/... ) route their string
// content through translateServerMessage so known backend (server) messages are
// displayed in the current UI language. All other strings pass through unchanged.
// Non-content methods (dismiss/update/isActive/done/...) are forwarded untouched.

const CONTENT_METHODS = new Set([
  "success",
  "error",
  "info",
  "warn",
  "warning",
  "dark",
  "loading",
  "promise",
]);

/** @type {Record<string, (...args: any[]) => any>} */
const translated = Object.keys(rawToast).reduce((acc, method) => {
  const fn = rawToast[method];
  if (typeof fn !== "function") return acc;
  if (!CONTENT_METHODS.has(method)) {
    acc[method] = fn;
    return acc;
  }
  acc[method] = (...args) => {
    if (args.length && typeof args[0] === "string") {
      args[0] = translateServerMessage(args[0]);
    }
    return fn(...args);
  };
  return acc;
}, {});

export const toast = translated;
export default toast;
